/**
 * Service-worker registration.
 *
 * Runs only in production (`import.meta.env.PROD === true`) and only when
 * the browser supports service workers. During dev we skip registration
 * entirely so HMR + stale caches don't fight each other.
 *
 * Call once from main.jsx after the initial render.
 */

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  // Wait until the load event so the browser has spare cycles for the
  // registration request — recommended pattern from web.dev.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silent fail — PWA is a progressive enhancement; the app continues
      // to work without it.
    });
  });
}
